import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';
import './style.css';

CustomAccordion.propTypes = {
    title: PropTypes.string,
    content: PropTypes.node,
    collapsible: PropTypes.bool,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    showBorderBottom: PropTypes.bool,
    showExpandTitle: PropTypes.bool,
    expandIconColor: PropTypes.string,
    titleStyle: PropTypes.object,
};

CustomAccordion.defaultProps = {
    title: '',
    content: null,
    collapsible: true,
    className: '',
    contentClassName: '',
    showBorderBottom: true,
    showExpandTitle: true,
    expandIconColor: AppColors.primary,
    titleStyle: {},
};

function CustomAccordion(props) {
    const {
        className,
        contentClassName,
        title,
        content,
        collapsible,
        showBorderBottom,
        showExpandTitle,
        expandIconColor,
        titleStyle,
    } = props;
    const [activeKey, setActiveKey] = useState('0');

    const toggleAccordion = () => {
        if (!collapsible) return;
        setActiveKey(activeKey === '0' ? null : '0');
    };

    return (
        <div className="w-100">
            <Accordion activeKey={activeKey}>
                <Accordion.Item
                    eventKey="0"
                    className={`p-0 ${className}`}
                    style={{
                        borderRadius: 10,
                    }}
                >
                    <Accordion.Header
                        className="p-4"
                        onClick={toggleAccordion}
                        style={{
                            borderBottom: showBorderBottom && activeKey === '0' ? `1px solid ${AppColors.gray[300]}` : '',
                        }}
                    >
                        <div className="d-flex align-items-center w-100">
                            <div
                                style={{
                                    color: AppColors.gray[900],
                                    fontSize: Utils.returnFontSize(14),
                                    fontWeight: 600,
                                    ...titleStyle, // Áp dụng titleStyle từ props
                                }}
                            >
                                {title}
                            </div>

                            {collapsible && (
                                <div
                                    className="ml-auto"
                                    style={{
                                        color: AppColors.primary,
                                        fontSize: Utils.returnFontSize(14),
                                        fontWeight: 600,
                                    }}
                                >
                                    {showExpandTitle ? (activeKey === '0' ? 'Thu gọn' : 'Mở rộng') : ''}{' '}
                                    <span>
                                        <i
                                            style={{ color: expandIconColor }}
                                            className={`fas fa-caret-${activeKey === '0' ? 'up' : 'down'}`}
                                        ></i>
                                    </span>
                                </div>
                            )}
                        </div>
                    </Accordion.Header>

                    <Accordion.Body className={`px-4 ${contentClassName}`}>
                        {content}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
}

export default CustomAccordion;